<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import {computed} from "vue";

const props = defineProps<{ text: string }>();
let text = computed(() => Translator.translateId(props.text));
</script>

<template>
  <div :title="text"
       class="tw-flex tw-flex-row tw-gap-1 tw-content-center tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark tw-items-center">
    <slot/>
    <span v-text="text"/>
  </div>
</template>
